// CONSTANTS are all caps.
const NS = 'MiniCart';
const CLS = 'miniCart';
const WG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/miniCart.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'
import * as Cart from '../../../../global/js/cart';
import * as utils from '../../../../global/js/utils';

export class MiniCart {
	constructor($el) {
		// $el is the widget node return by the miniCart function
		this.$el = $el;
	}

	init() {
		this.setMiniCart();
	}

	setMiniCart() {
		// Add Some logic here
		const This = this;
		const $miniCart = $(this.$el);
		let $removeCartEndPoint = $miniCart.data('removeEndpointApi');
		let $modal = $(document).find('.remove-item-minicart-modal');
		let $mobileCart = $('.miniCart.is-mobileCart');
		this.itemId = '';
		this.itemName = '';
		this.attendeeNames = '';

		// initial
		$miniCart.not('.is-sidebar').hide();

		$miniCart.on('click', '.miniCart-removeItem', function() {
			This.itemId = $(this).data('itemId');
			This.itemName = $(this).data('itemName');
			This.attendeeNames = $(this).data('attendeenames');

			$modal.data('itemId', This.itemId);
			$modal.data('attendeenames', This.attendeeNames);
			$modal.find('.modal-title').text('Remove ' + This.itemName);
			$modal.find('.error-messages').removeClass('is-active').text('');
			$modal.modal('show');
		});

		if (!window.initCartFunc) {
			$(document).on('click', '.cart-toggle', (e) => {
				$(e.currentTarget).toggleClass('is-open');
				$mobileCart.slideToggle('fast');
				$mobileCart.toggleClass('is-open');
			});

			$modal.find('.confirm-remove-btn').on('click', function() {
				// toggle spinners (spinner is outside the main page)
				let $data = {
					id: $modal.data('itemId') || '',
					attendeeNames: $modal.data('attendeenames'),
				};

				if ($data && $data.id != '') {
					$('.loading-spinner').addClass('is-active');

					fetch($removeCartEndPoint, {
							method: 'post',
							body: JSON.stringify($data).replace(/>/g, '&gt;'),
							credentials: 'same-origin',
							headers: new Headers({
								'Content-Type': 'application/json',
							}),
						})
						.then((resp) => resp.json())
						.then(function(data) {
							if (data.result == 'SUCCESS') {
                if (window.Evergage) {
                  window.Evergage.sendEvent({itemAction: window.Evergage.ItemAction.RemoveFromCart, cart: {singleLine: {Product: {_id: $data.id, price: 1, quantity: 1}}}});
                }
								// data.response
								if (data.isempty) {
									// refresh page to show empty cart page
									location.reload();
									return;
								}
								// remove the item
								let $removedId = data.response.id;
								// need to remove from both instances (header on phone, sidebar)
								$(document).find('.miniCart-item[data-item-id="' + $removedId + '"]').fadeOut(500, function() {
									$(this).remove();
								});
								// Also if page is a cart page, remove from cart
								$(document).find('.shoppingCartItem[data-id="' + $removedId + '"]').fadeOut(500, function() {
									$(this).remove();
								});

								Cart.updateCart(data.response.cartSummary);

								// close the modal
								$modal.modal('hide');
							} else {
								// keep the modal open and show error div
								$modal.find('.error-messages').addClass('is-active').text(data.message);
							}
							// toggle spinners
							$('.loading-spinner').removeClass('is-active');
						})
						.catch(function(msg) {
							// keep the modal open and show error div
							$modal.find('.error-messages').addClass('is-active').text(msg);
							// toggle spinners
							$('.loading-spinner').removeClass('is-active');
						});
				}
			});

			window.initCartFunc = true;
		}
	}
	// Add more functions like on above here
}



// WEBPACK FOOTER //
// C:/Users/GavinDow/source/repos/FrontEndWebsite/src/views/widgets/miniCart/js/miniCart.js